import type { Config } from "tailwindcss";

export default {
  theme: {
    extend: {
      maxWidth: {
        "8xl": "1440px",
      },

      transitionDuration: {
        default: "250ms",
      },

      transitionDelay: {
        default: "250ms",
      },

      spacing: {
        86: "21.5rem",
        88: "22rem",
      },

      zIndex: {
        // UI
        header: "100",
        tooltip: "200",
        navbar: "400",
        navbarMenu: "401",
        blurredBackground: "500",
        modal: "600",
        toast: "700",
      },

      keyframes: {
        border: {
          to: { "--border-angle": "360deg" },
        },
        loader: {
          "0%": {
            left: "-40%",
          },
          "50%": {
            left: "20%",
            width: "80%",
          },
          "100%": {
            left: "100%",
            width: "100%",
          },
        },
      },
      animation: {
        border: "border 4s linear infinite",
        loader: "loader 1s linear infinite",
      },

      backgroundImage: {
        "gold-gradient":
          "linear-gradient(223.97deg, rgba(255, 250, 221, 0.2) 11.07%, rgba(255, 218, 121, 0.2) 32.21%, rgba(255, 215, 0, 0.2) 64.57%, rgba(255, 255, 255, 0.2) 89.07%)",
      },
    },

    colors: {
      // Action
      "primary-100": "#FFFE3E",
      "secondary-100": "#9E4FF4",

      // Background
      "background-100": "#1F0C19",
      "background-95": "#2A1825",
      "background-90": "#362431",
      "background-85": "#41303B",
      "background-80": "#4D3D48",

      // Foreground
      "foreground-100": "#FFFFFF",
      "foreground-95": "#E9E7E8",
      "foreground-90": "#D2CED1",

      // Neutral
      neutral: "#8D858C",
      "neutral-20": "#D2CED1",

      // Other
      success: "#0CC76E",
      error: "#F23F37",
      warn: "#FFC046",

      // Base colors
      inherit: "inherit",
      white: "#FFFFFF", // Alternatively, you can use "foreground-100"
      transparent: "transparent",
    },

    borderRadius: {
      DEFAULT: "4px",
      small: "4px",
      large: "8px",
      full: "9999px",
    },

    screens: {
      sm: `376px`,
      md: `768px`,
      sd: `1024px`,
      lg: `1280px`,
      xl: `1440px`,
      "2xl": `1920px`,
    },
  },
} satisfies Config["theme"];
